import { render } from "./riskList2.vue?vue&type=template&id=6bb5e72e&scoped=true"
import script from "./riskList2.vue?vue&type=script&lang=js"
export * from "./riskList2.vue?vue&type=script&lang=js"

import "./riskList2.vue?vue&type=style&index=0&id=6bb5e72e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6bb5e72e"

export default script